import { useCallback, useLayoutEffect, useRef } from 'react'

export const useDoubleClick = (onClick: () => void, onDbClick: () => void, delay = 300) => {
    const timePassed = useRef(0)
    const timeoutRef = useRef<NodeJS.Timeout | null>(null)

    useLayoutEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }
        }
    }, [])

    return useCallback(
        (e: React.MouseEvent) => {
            if (e.detail === 1) {
                timeoutRef.current = setTimeout(() => {
                    if (Date.now() - timePassed.current >= delay) {
                        onClick()
                    }
                }, delay)
            }

            if (e.detail === 2) {
                timePassed.current = Date.now()
                onDbClick()
            }
        },
        [onClick, onDbClick, delay]
    )
}
